export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              被窝网电影
            </h3>
            <p className="text-sm text-foreground-300 leading-relaxed">
              被窝网电影致力于打造一站式免费高清影视资源聚合平台，汇集海量电影、电视剧、综艺、动漫等优质内容，无需缓冲流畅观看，让每一位影迷都能在被窝里享受极致的观影体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '影视速看', href: '#media' },
                { label: '最新动态', href: '#updates' },
                { label: '热播榜单', href: '#ranking' },
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      const target = document.querySelector(link.href);
                      if (target) target.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">影视分类</h3>
            <ul className="space-y-2.5">
              {['动作电影', '喜剧电影', '科幻电影', '爱情电影', '悬疑电影', '动漫番剧'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#index"
                    onClick={(e) => {
                      e.preventDefault();
                      const target = document.querySelector('#index');
                      if (target) target.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">合作伙伴</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              诚邀优质影视内容方、媒体平台与品牌方合作，共同为广大影迷提供更丰富的高清影视资源与观影服务。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/40">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 被窝网电影 Beiwowang. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">返回顶部</a>
              <a href="#faq" className="text-xs text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">帮助中心</a>
              <a href="#contact" className="text-xs text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">意见反馈</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}